/* reBase live-version notifier: never refresh a customer's page without permission. */
(function () {
  'use strict';
  var meta = document.querySelector('meta[name="rebase-release"]');
  if (!meta || !meta.content || !window.fetch) return;
  var originalRelease = meta.content;
  var notified = false;
  var lastCheck = 0;
  var intervalMs = 60000;
  function showNotice() {
    if (notified || document.getElementById('rebase-update-notice')) return;
    notified = true;
    var box = document.createElement('div');
    box.id = 'rebase-update-notice';
    box.setAttribute('role','status');
    box.setAttribute('aria-live','polite');
    var message = document.createElement('span');
    message.textContent = 'Megújult az oldal! Új verzió érhető el.';
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Frissítés';
    button.addEventListener('click', function () { window.location.reload(); });
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'rebase-update-close';
    close.setAttribute('aria-label','Frissítési értesítés bezárása');
    close.textContent = '×';
    close.addEventListener('click',function(){box.remove();});
    box.appendChild(message);
    box.appendChild(button);
    box.appendChild(close);
    document.body.appendChild(box);
  }
  function check() {
    if (document.hidden || notified || Date.now()-lastCheck < intervalMs-2000) return;
    lastCheck = Date.now();
    var url = new URL(window.location.href);
    url.searchParams.set('_rebase_check', String(Date.now()));
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function(){controller.abort();},8000) : null;
    fetch(url.toString(), {
      method:'GET',
      cache:'no-store',
      credentials:'same-origin',
      headers:{'Accept':'text/html'},
      signal:controller ? controller.signal : undefined
    }).then(function(response) {
      if(!response.ok || !(response.headers.get('content-type') || '').includes('text/html')) return null;
      return response.text();
    }).then(function(html) {
      if(!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var current = parsed.querySelector('meta[name="rebase-release"]');
      if(current && current.content && current.content !== originalRelease) showNotice();
    }).catch(function(){ /* Offline/network issues are not update signals. */ }).finally(function(){if(timeout)clearTimeout(timeout);});
  }
  window.setInterval(check,intervalMs);
  document.addEventListener('visibilitychange',function(){if(!document.hidden){lastCheck=0;check();}});
  window.addEventListener('pageshow',function(event){if(event.persisted){lastCheck=0;check();}});
})();